import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Text } from '@unimed-fesp/components';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import {
  USER_KEY,
  getUserData,
  excludeData,
  getLocalObj,
  getRefreshToken,
  isAccessTokenValid,
  getTokenAccessToken,
} from '../../services/auth';
import history from '../../services/history';

import { Creators as AuthActions } from '../../store/ducks/auth';

// #region Componentes
import LoadingIcon from '../../components/Icons/LoadingIcon';
import FormLogin from '../../components/organisms/FormLogin';
// #endregion

import {
  LoginLink,
  EsqueciMinhaSenhaContainer,
  DificuldadesAcessoContainer,
} from './styles';

const { REACT_APP_EMAIL_DIFICULDADES_ACESSO } = process.env;

function LoginPart() {
  const { usuario, loggedIn, postLogin } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const formRef = useRef(null);

  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const queryEmail = params.get('email');

  const loginData = {
    usuario: queryEmail || '',
    senha: '',
  };

  const mailTo = `mailto:${REACT_APP_EMAIL_DIFICULDADES_ACESSO}`;
  const [loginParams, setLoginParams] = useState(loginData);

  async function handleSubmitLogin(data) {
    try {
      const schema = Yup.object().shape({
        usuario: Yup.string()
          .email('E-mail inválido')
          .required('O e-mail é obrigatório'),
        senha: Yup.string().trim().required('A senha é obrigatória'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      const formLoginParams = {
        userId: data.usuario,
        password: data.senha.trim(),
        grantType: 'password',
      };

      dispatch(AuthActions.postLoginRequest(formLoginParams));

      formRef.current.setErrors({});
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errorMessages = {};

        error.inner.forEach((err) => {
          errorMessages[err.path] = err.message;
        });

        formRef.current.setErrors(errorMessages);
      }
    }
  }

  function handleFormForgottenPassword() {
    history.push('/novo/login/redefinir-senha');
  }

  useEffect(() => {
    if (usuario.changePassword)
      history.push('/novo/recuperar-senha', { isChangePassword: true });
  }, [usuario.changePassword]);

  useEffect(() => {
    if (loggedIn) history.push('/novo/lista');

    if (getLocalObj(USER_KEY) && !loggedIn) {
      if (getTokenAccessToken() && isAccessTokenValid()) {
        dispatch(AuthActions.signInRequest(getUserData()));
      } else if (getRefreshToken() && !isAccessTokenValid()) {
        dispatch(AuthActions.refreshInvalidTokenRequest(getTokenAccessToken()));
      } else {
        excludeData();
        dispatch(AuthActions.signOut());
      }
    }
  }, [dispatch, loggedIn]);

  return (
    <Form ref={formRef} onSubmit={handleSubmitLogin}>
      <FormLogin
        loginParams={loginParams}
        setLoginParams={setLoginParams}
        formRef={formRef.current}
        marginTop="80px"
      />
      <Button
        tipo="primary"
        marginLeft={189.5}
        marginTop={25}
        borderRadius={5}
        border="#00995d"
        height={40}
        width={141}
        type="submit"
        justifyCenter
        alignCenter
        marginBottom={25}
        display={postLogin.loading && 'none'}
        font="16px unimed_slabregular"
      >
        conectar
      </Button>
      {postLogin.loading && (
        <LoadingIcon
          size="35"
          width="400px"
          marginTop="40px"
          marginLeft="60px"
        />
      )}
      <EsqueciMinhaSenhaContainer>
        <Text marginRight={8} marginLeft={104.17} text="esqueceu sua senha?" />
        <LoginLink onClick={handleFormForgottenPassword} href="#">
          clique aqui para redefini-la
        </LoginLink>
      </EsqueciMinhaSenhaContainer>
      <DificuldadesAcessoContainer>
        <Text marginRight={8} text="dificuldades no acesso?" />
        <LoginLink title={REACT_APP_EMAIL_DIFICULDADES_ACESSO} href={mailTo}>
          fale com o nosso Suporte.
        </LoginLink>
      </DificuldadesAcessoContainer>
    </Form>
  );
}

export default LoginPart;
